import './style.scss';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useMemo } from 'react';
import { useForm, useFormState } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useParams, useSearchParams } from 'react-router-dom';
import ReactRouterPrompt from 'react-router-prompt';
import PropTypes from 'prop-types';
import { getReviewerInfo } from 'apis/liquidationReviews.api';

import DynamicLiquidationForm from 'features/LiquidationReview/components/DynamicLiquidationReview';

export default function LiquidationReviewCRUForm({ readOnly }) {
  // #region Data
  const { t } = useTranslation();

  const { projectProposalId } = useParams();
  const [searchParams] = useSearchParams();

  const councilMemberId = searchParams.get('councilMemberId');
  const userId = searchParams.get('userId');
  const councilId = searchParams.get('councilId');

  const { control } = useForm({
    mode: 'onChange',
  });

  const { isDirty, dirtyFields } = useFormState({ control });

  // A. General Information
  const { data: infoData, isLoading } = useQuery(
    ['acceptance-reviewer', userId, councilId, projectProposalId],
    () => getReviewerInfo(userId, projectProposalId, councilId, projectProposalId)
  );
  const info = useMemo(() => infoData?.data, [infoData]);

  // #endregion

  const footerConfirmationPrompt = (onConfirm, onCancel) => (
    <div>
      <Button
        label={t('formLayout.action.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={onCancel}
        autoFocus
      />
      <Button
        label={t('formLayout.action.ok')}
        className="w-7rem"
        severity="info"
        onClick={onConfirm}
      />
    </div>
  );

  const renderFirstTab = () => (
    <DynamicLiquidationForm
      projectProposalId={projectProposalId}
      councilId={councilId}
      councilMemberId={councilMemberId}
      generalInfo={info?.projectProposal}
      isLoading={isLoading}
      readOnly={readOnly}
    />
  );
  // #endregion

  return (
    <>
      <ReactRouterPrompt when={isDirty && Object.keys(dirtyFields).length}>
        {({ isActive, onConfirm, onCancel }) => (
          <Dialog
            visible={isActive}
            header={<p className="text-blue-500">{t('projectProposal.confirmationTitle')}</p>}
            position="center"
            style={{ width: '300px' }}
            onHide={onCancel}
            draggable={false}
            footer={() => footerConfirmationPrompt(onConfirm, onCancel)}
          >
            <p className="text-lg py-3">{t('projectProposal.confirmationPromptMessage')}</p>
          </Dialog>
        )}
      </ReactRouterPrompt>
      {renderFirstTab()}
    </>
  );
}

LiquidationReviewCRUForm.propTypes = {
  readOnly: PropTypes.bool,
};

LiquidationReviewCRUForm.defaultProps = {
  readOnly: false,
};
